import { Component } from '@angular/core';

@Component({
    selector: 'rwidget-customer-account-edit-aside',
    templateUrl: './customer-account-edit-aside.component.html',
    styleUrls: ['./customer-account-edit-aside.component.scss'],
})
export class CustomerAccountEditAsideComponent {}
